var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLaun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.1,26.5l-21.3-8.4C65.5,18,65.2,18,65,18v0H35v0c-0.2,0-0.5,0-0.7,0.1l-21.3,8.4c-1.9,0.7-2.9,2.8-2.4,4.7l4,15.2   c0.5,1.8,2.1,3,3.9,3c0.4,0,0.9-0.1,1.3-0.2l4.5-1.5l2.8,41.5c0.1,1.6,1.4,2.8,3,2.8h40.1c1.6,0,2.9-1.2,3-2.8l2.8-41.5l4.5,1.5   c0.4,0.1,0.8,0.2,1.3,0.2c0,0,0,0,0,0c1.8,0,3.4-1.2,3.9-3l4-15.2C90,29.3,89,27.2,87.1,26.5z M62.8,22c-1,6.2-6.3,11-12.8,11   c-6.5,0-11.9-4.8-12.8-11H62.8z M81.6,45.4l-5.7-1.9c-0.3-0.1-0.6-0.2-1-0.2c-1.6,0-2.9,1.2-3,2.8L69.1,88H30.9l-2.8-41.8   c-0.1-1.6-1.4-2.8-3-2.8c-0.3,0-0.6,0.1-0.9,0.2l-5.7,1.9l-4-15.2l18.8-7.4C34.6,30.9,41.6,37,50,37c8.4,0,15.4-6.1,16.8-14.2   l18.8,7.4L81.6,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2,19l-3,0.9c-0.2,0.1-0.4-0.1-0.3-0.3l0.9-3c0,0,0-0.1,0-0.1l-0.9-3c-0.1-0.2,0.1-0.4,0.3-0.3l3,0.9c0,0,0.1,0,0.1,0   l3-0.9c0.2-0.1,0.4,0.1,0.3,0.3l-0.9,3c0,0,0,0.1,0,0.1l0.9,3c0.1,0.2-0.1,0.4-0.3,0.3l-3-0.9C84.3,19,84.2,19,84.2,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,63.8l-3,0.9c-0.2,0.1-0.4-0.1-0.3-0.3l0.9-3c0,0,0-0.1,0-0.1l-0.9-3C81,58.1,81.1,58,81.3,58l3,0.9c0,0,0.1,0,0.1,0   l3-0.9c0.2-0.1,0.4,0.1,0.3,0.3l-0.9,3c0,0,0,0.1,0,0.1l0.9,3c0.1,0.2-0.1,0.4-0.3,0.3l-3-0.9C84.4,63.8,84.3,63.8,84.3,63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9,10.8l1.5-2.7c0.1-0.2,0.3-0.2,0.4,0l1.5,2.7c0,0,0.1,0.1,0.1,0.1l2.7,1.5c0.2,0.1,0.2,0.3,0,0.4l-2.7,1.5   c0,0-0.1,0.1-0.1,0.1l-1.5,2.7c-0.1,0.2-0.3,0.2-0.4,0l-1.5-2.7c0,0-0.1-0.1-0.1-0.1l-2.7-1.5c-0.2-0.1-0.2-0.3,0-0.4L22.9,10.8   C22.9,10.9,22.9,10.9,22.9,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,12.4L68.3,13c-0.2,0-0.3-0.1-0.2-0.2l0.6-2.2c0,0,0-0.1,0-0.1L68,8.3C68,8.1,68.1,8,68.3,8l2.2,0.6c0,0,0.1,0,0.1,0   L72.8,8C72.9,8,73,8.1,73,8.3l-0.6,2.2c0,0,0,0.1,0,0.1l0.6,2.2c0,0.2-0.1,0.3-0.2,0.2l-2.2-0.6C70.5,12.4,70.5,12.4,70.5,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,58.2l1.1-2c0.1-0.1,0.3-0.1,0.4,0l1.1,2c0,0,0,0.1,0.1,0.1l2,1.1c0.1,0.1,0.1,0.3,0,0.4l-2,1.1c0,0-0.1,0-0.1,0.1   l-1.1,2c-0.1,0.1-0.3,0.1-0.4,0l-1.1-2c0,0,0-0.1-0.1-0.1l-2-1.1c-0.1-0.1-0.1-0.3,0-0.4L16.2,58.2C16.1,58.2,16.2,58.2,16.2,58.2z   "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaun);
export default __webpack_public_path__ + "static/media/LAUN.14afbf71.svg";
export { ForwardRef as ReactComponent };